import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {User} from "@core/shared/models/user";
import {FormService} from "@core/shared/services/form.service";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {UserService} from "@core/shared/services/user.service";

@Component({
    selector: 'app-page-administrator-update',
    templateUrl: './page-administrator-update.component.html',
    styleUrls: ['./page-administrator-update.component.scss'],
    providers: [
        FormService
    ],
    standalone: false
})
export class PageAdministratorUpdateComponent implements OnInit {

    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        private _formBuilder: UntypedFormBuilder,
        private _translateService: TranslateService,
        private _snackBar: MatSnackBar,
        private _userService: UserService,
        public formService: FormService
    ) {
    }

    ngOnInit(): void {

        this._initForm();

        this._route.data.subscribe((data: { user: User }): void => {

            this.form.patchValue(data.user);
        });
    }

    private _initForm(): void {

        this.formService.form = this._formBuilder.group({
            lastName: ['', [Validators.required]],
            firstName: ['', [Validators.required]]
        });

        this.formService.submitCallback = (): void => {

            this._userService.updateItemAPI(this._route.snapshot.params['id'], this.form.value).subscribe((): void => {

                this._snackBar.open(this._translateService.instant('administrator.update.success.value'), this._translateService.instant('notification.close.action.value'), {
                    duration: 5000
                });

                this.redirectToList();
            });
        };
    }

    public redirectToList(): void {

        this._router.navigate(['account/administrator/list']);
    }

    get form(): UntypedFormGroup {

        return this.formService.form;
    }
}
